import type {
  AcceptIncomingCallRequest,
  AcceptIncomingCallUsecase,
} from '@usecases/accept-incoming-call.usecase';
import type { BaseController } from '@infra/controllers/base.controller';

export type AcceptIncomingCallInput = {
  recordId: string;
};

export type AcceptIncomingCallOutput = void;

export class AcceptIncomingCallController
  implements BaseController<AcceptIncomingCallInput, AcceptIncomingCallOutput>
{
  constructor(private usecase: AcceptIncomingCallUsecase) {}

  async handle(
    req: AcceptIncomingCallInput,
  ): Promise<AcceptIncomingCallOutput> {
    const metadata: AcceptIncomingCallRequest = {
      crmMetadata: {
        vendorCallId: req.recordId,
      },
    };
    await this.usecase.run(metadata);
  }
}
